import { Link } from "react-router-dom";
import { articles, hotRanking } from "@/mocks/news";
import { formatHeat } from "@/utils/format";
import NewsCard from "@/components/feature/NewsCard";

export default function HotRanking() {
  const sideList = articles.slice(4, 7);

  return (
    <section aria-label="热瓜榜" className="w-full bg-background-50">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10">
          <div className="lg:col-span-5">
            <p className="text-xs font-label text-accent-700 tracking-widest mb-2">HOT RANKING</p>
            <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950">
              此刻热瓜榜
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              依据全站阅读与转发实时计算，每十分钟滚动一次。
            </p>

            <ol className="mt-6 rounded-lg border border-background-200 overflow-hidden">
              {hotRanking.map((item, index) => (
                <li
                  key={item.id}
                  className="border-b border-background-200 last:border-b-0 bg-background-50 hover:bg-background-100/60 transition-colors"
                >
                  <Link
                    to={`/news/${item.id}`}
                    className="flex items-center gap-4 px-4 py-3.5 cursor-pointer group"
                  >
                    <span
                      className={`w-7 h-7 shrink-0 flex items-center justify-center rounded-md font-heading text-sm font-black ${
                        index < 3
                          ? "bg-primary-500 text-background-50"
                          : "bg-background-200 text-foreground-600"
                      }`}
                    >
                      {index + 1}
                    </span>
                    <span className="flex-1 text-sm text-foreground-800 leading-snug line-clamp-1 group-hover:text-primary-600 transition-colors">
                      {item.title}
                    </span>
                    <span className="shrink-0 text-xs font-label text-foreground-500 flex items-center gap-1">
                      <i className="ri-fire-line text-primary-500" aria-hidden="true"></i>
                      {formatHeat(item.heat)}
                    </span>
                  </Link>
                </li>
              ))}
            </ol>
          </div>

          <div className="lg:col-span-7">
            <div className="flex items-center justify-between mb-4">
              <h3 className="font-heading text-lg font-bold text-foreground-900">
                <a href="#latest" className="hover:text-primary-600 transition-colors">
                  编辑推荐
                </a>
              </h3>
              <Link
                to="/dispatch/headline"
                className="text-xs font-label text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap"
              >
                更多头条专递 <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
              {sideList.slice(0, 2).map((article) => (
                <NewsCard key={article.id} article={article} />
              ))}
            </div>
            <div className="mt-6 rounded-lg border border-background-200 bg-secondary-50 p-5">
              <h4 className="font-heading text-sm font-bold text-secondary-900 flex items-center gap-2">
                <i className="ri-lightbulb-flash-line text-secondary-600" aria-hidden="true"></i>
                怎么吃瓜才不被带节奏
              </h4>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                先看是否有可核对的官方表述，再看时间线是否自洽，最后再看各方说法是否并列呈现。
                本站每篇突发事件都会保留这三个部分，方便你自行判断。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}